import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TextControl } from '../InputControls';
import { makeRequest, validateEmail } from '../../utils';

export default function AboutPage() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  document.title = `Series One | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `First series includes books by John Ashbery, Cookie Mueller, Eileen Myles, René Daumal, Max Beckmann, and Dodie Bellamy`);


  return (
    <div className='pageContainer'>
      <ul className='menu'>
        <li><Link to='/about'>About</Link></li>
        <li><span className='chosen'>Series One</span></li>
        <li><Link to='/from-the-editors'>From the Editors</Link></li>
        <li><Link to='/contact'>Contact</Link></li>
      </ul>
      <div className='mainText'>
        <h2>Series One</h2>
        <p><strong>A tribute to what came before.</strong></p>
        <p>Hanuman Editions pays homage to the editors and contributors of Hanuman books c. 1986–1993. We will begin our series by publishing a series of six reissues as dedication, followed by one reissue in every series here on, so the old and the new are always intertwined.</p>

        <p>The older Hanuman Books are cult objects and hard to come by. If they do appear, they are prohibitively expensive. We have the good fortune of being given a set of the books by Raymond Foye, one of the founding Editors of Hanuman Books. We live with them everyday at the studio, a generous and abundant presence. They are as beautiful and iconic as they are playful; from John Ashbery to Patti Smith, Bob Dylan to Simone Weil, Willem De Kooning to Jean Genet, et al.</p>

        <p>Somewhere along the way as we worked with new contributors, we decided to bring the older ones to you too, a past presentness of some of the coolest writers, thinkers, artists of an epoch gone by, but one that is resoundingly enduring.</p>
        <hr />
        <div className='productList boxSet'>
          <div className='productImage'>
            <img src='../../grid.png' />
            <a className='productBuySlim' href='https://asterismbooks.com/product/hanuman-editions-series-1-box-set-candy-pink' target='_blank'>Buy Now <span className='variant'>(Candy Pink)</span></a>
            <a className='productBuySlim' href='https://asterismbooks.com/product/hanuman-editions-series-1-box-set-emerald' target='_blank'>Buy Now <span className='variant'>(Emerald Green)</span></a>
            <a className='productBuySlim' href='https://asterismbooks.com/product/hanuman-editions-series-1-box-set-azure-blue' target='_blank'>Buy Now <span className='variant'>(Azure Blue)</span></a>
            <a className='productBuySlim' href='https://asterismbooks.com/product/hanuman-editions-series-1-box-set-turquoise' target='_blank'>Buy Now <span className='variant'>(Turquoise)</span></a>

          </div>
          <div>
            <h2 className='productTitle'>Hanuman Editions Series One Box Set</h2>
            <div className='productAuthor'>$99.99</div>

            <div className='product-description'>
              <p>While all titles are available individually, we have produced a special box set for our inaugural series, featuring all six titles. Only 300 will be produced, 75 in each of four colors: Azure Blue, Candy Pink, Turquoise, and Emerald. Each box will be hand-numbered, and while we intend to keep all of the titles in print, this will be the only production of this particular set.</p>
            </div>
            <div className='productStats'>168 pp. / ISBN 979–8–989378–04–3</div>
          </div>
        </div>

        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../beckmann.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/on-my-painting-max-beckmann' target='_blank'>Buy Now</a>
          </div>
          <div>
            <h2 className='productTitle'>On My Painting</h2>
            <div className='productAuthor'>Max Beckmann</div>

            <div className='product-description'>
              <p>Compiled and edited by George Scrivani for Hanuman Books in 1988, <em>On My Painting</em> collects six texts from the pioneering German artist Max Beckmann, who fled Nazi Germany after his paintings—increasingly moody and reflective of the existential terror of the time—were labeled "degenerate". In addition to the titular essay, this volume contains short pieces "Creative Credo" and "The New Program", extracts from his <em>Diaries</em>, three "Letters to a Woman Painter", and the text of a speech given to the philosophy faculty at Washington University in St. Louis, shortly before his death in 1950.</p>

              <p><strong>Max Beckmann</strong> (1884-1950) was a German artist whose body of work includes painting and sculpture. A rising star during the Weimar era, Beckmann left Germany following the ascent of Adolf Hitler, living in self-imposed exile in Amsterdam before finally being granted a teaching position in the United States in 1947. He died of a heart attack in 1950. Though he eschewed the label of "Expressionism", he is often associated with the movement, and was heavily influential on the American offshoots that followed.</p>
            </div>
            <div className='productStats'>128 pp. / ISBN 979–8–989378–00–5</div>
          </div>
        </div>

        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../ashbery.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/the-ice-storm-john-ashbery' target='_blank'>Buy Now</a>

          </div>
          <div>
            <h2 className='productTitle'>The Ice Storm</h2>
            <div className='productAuthor'>John Ashbery</div>

            <div className='product-description'>
              <p>Published in 1987 as a standalone volume by Hanuman Books, John Ashbery's "The Ice Storm" is an extended prose-poem by one of the most important and influential poets of our time.</p>

              <p>John Ashbery (1927-2017) was an American poet and critic. Referred to often as an "avant-garde" poet, "experimentalist", or "surrealist", Ashbery's work resisted easy classification. He was awarded nearly every major prize for an American poet during his career, including a Pulitzer Prize in 1967 for <em>Self-Portrait in a Convex Mirror</em>.</p>
            </div>
            <div className='productStats'>64 pp. / ISBN 979–8–989378–01–2</div>
          </div>
        </div>

        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../bellamy.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/feminine-hijinx-dodie-bellamy' target='_blank'>Buy Now</a>

          </div>
          <div>
            <h2 className='productTitle'>Feminine Hijinx</h2>
            <div className='productAuthor'>Dodie Bellamy</div>

            <div className='product-description'>
              <p>Already a member of The Feminist Writers’ Guild and one of the principle founders/proponents of the New Narrative movement, Dodie Bellamy published her first book with Hanuman Books in 1991. Feminine Hijinks brings together two long pieces, "Complicity" and "The Debbies I Have Known", along with a new introduction by the author, written for this reissue.</p>

              <p><strong>Dodie Bellamy</strong> (b. 1951) is an American writer, journalist, and educator, most often associated with the New Narrative movement. She is the author of <em>The Letters of Mina Harker, Cunt-ups, Pink Steam, The TV Sutras</em>, and co-edited <em>Writers Who Love Too Much: New Narrative Writing 1977–1997</em> with Kevin Killian.</p>
            </div>
            <div className='productStats'>176 pp. / ISBN 979–8–989378–02–9</div>
          </div>
        </div>


        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../mueller.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/garden-of-ashes-cookie-mueller' target='_blank'>Buy Now</a>

          </div>
          <div>
            <h2 className='productTitle'>Garden of Ashes</h2>
            <div className='productAuthor'>Cookie Mueller</div>

            <div className='product-description'>
              <p><em>Garden of Ashes</em>, Cookie Mueller's second entry into the Hanuman Books canon (following 1988's <em>Fan Mail, Frank Letters, and Crank Calls</em>) brings together ten stories, autobiographical accounts of her ascent to cult-cinema superstardom, with tales dedicated to several of her fellow Dreamlanders, including "Edith Massey: A Star" and "Divine".</p>

              <p><strong>Cookie Mueller</strong> (1949–1989) was an American writer, actress, and advice columnist, best remembered as a regular cast member of some of the director John Waters's groundbreaking films, including Multiple Maniacs, Pink Flamingos, Female Trouble, and Desperate Living. She died from AIDS-related complications in 1989.</p>
            </div>
            <div className='productStats'>120 pp. / ISBN 979–8–989378–02–9</div>
          </div>
        </div>

        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../myles.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/bread-and-water-eileen-myles' target='_blank'>Buy Now</a>

          </div>
          <div>
            <h2 className='productTitle'>Bread and Water</h2>
            <div className='productAuthor'>Eileen Myles</div>

            <div className='product-description'>

              <p>First published by Hanuman Books in 1986, <em>Bread and Water</em> is the debut short story collection by the renowned poet Eileen Myles, assembling six stories with an autobiographical flavor, of being a queer, working-class poet with a penchant for mischief. Stories include: "Light Warrior", "21, 22, 23…, "Merry Christmas Mr. Title", "Bath, Maine", "Bread and Water", and "Everybody Would Go Play Cards at Eddie and Nonie's".</p>

              <p><strong>Eileen Myles</strong> (b. 1949) is an American writer, poet, artist, teacher, and playwright. They are the author of more than twenty books, including <em>Sappho's Boat, Chelsea Girls, Afterglow</em>, and <em>For Now</em>.</p>
            </div>
            <div className='productStats'>168 pp. / ISBN 979–8–989378–04–3</div>
          </div>
        </div>

        <hr />

        <div className='productList'>
          <div className='productImage'>
            <img src='../../daumal.png' />
            <a className='productBuy' href='https://asterismbooks.com/product/the-lie-of-the-truth-rene-daumal' target='_blank'>Buy Now</a>

          </div>
          <div>
            <h2 className='productTitle'>The Lie of the Truth</h2>
            <div className='productAuthor'>René Daumal</div>

            <div className='product-description'>
              <p>In this brief, dense essay, Daumal bids us to resist the very notion of the truth, and to recognize it as an artistic and metaphysical dead-end.</p>

              <p>René Daumal (1908-1944) was a French poet and writer often associated with surrealism (though he fought against the label), spiritualism, and 'pataphysics. He is perhaps best remembered for the posthumously published novel, <em>Mount Analogue</em> (1952).</p>
            </div>
            <div className='productStats'>64 pp. / ISBN 979–8–989378–05–0</div>
          </div>
        </div>


      </div>
    </div>
  )
}